import * as React from 'react';
import * as cx from 'classnames';
import S from 's-js';
import SuperCritical, { SuperCriticalComponent, SuperCriticalReference } from 'lib/supercritical';
import { noDefault } from 'lib/eventWrappers';
import { tzmoment } from 'lib/tzmoment';
import { TZUtils } from 'lib/TZUtils';

import { ServicesDashboard, Column, Columns } from './servicesdashboard'
import { DatePicker } from 'portcall/datetimepicker/view';
import { PageLoadingIndicator } from 'core/actionloadingindicator/view';
import { TopicCard } from 'data/models/TopicCard';
import { TopicCardStatus } from 'server/enums/TopicCardStatus';

const StatusNames : { [ key: number ] : string } = {
    [TopicCardStatus.Confirmed]: 'Confirmed',
    [TopicCardStatus.Denied]: 'Denied',
    [TopicCardStatus.PendingReview]: 'Pending'
};

export let ServicesDashboardView = SuperCritical(({ model: m, tzutils } : { model : ServicesDashboard, tzutils : TZUtils }) =>
        <div className="services-dashboard">
            <ControlsView model={m} tzutils={tzutils} />
            <PageLoadingIndicator loading={m.Loading} />
            <ServicesTable model={m} />
        </div>
    ),
    ControlsView = class extends SuperCriticalComponent<{ model : ServicesDashboard, tzutils : TZUtils }> {
        calendarRef : (el : HTMLDivElement | null) => void;
        calendar : any;

        constructor(props : { model : ServicesDashboard, tzutils : TZUtils }) {
            super(props);

            this.calendarRef = SuperCriticalReference(this, ({ model, tzutils } : { model : ServicesDashboard, tzutils : TZUtils }, el : HTMLDivElement | null) => {
                this.calendar = (window as any).kendo.jQuery(el).kendoDatePicker({
                    change: function () {
                        var selectedDate = tzutils.tzify(this.value());
                        var diff = selectedDate.getTime() - S.sample(model.Date).getTime();
                        var diffInDays = Math.round(diff / (24 * 60 * 60 * 1000));
                        model.AddDays(diffInDays);
                    },
                    open: function () {
                        this.value(tzutils.localify(S.sample(model.Date)));
                    }
                }).data('kendoDatePicker');
            });
        }

        srender({ model: m } : { model : ServicesDashboard, tzutils : TZUtils }) {
            return (
                <div className="controls">
                    <input className="pc-reports-filter" type="text" placeholder="Filter By &mdash;"
                        value={m.Filter()}
                        onChange={e => m.Filter(e.currentTarget.value)} />
                        
                    <div className="date-navigator">
                        <div className="pc-button date-arrow" onClick={noDefault(() => m.AddDays(-1))}>
                            <span className="glyphicon glyphicon-chevron-left"></span>
                        </div>
                        <div className="pc-button today" onClick={noDefault(() => m.Date(m.Today))}>
                            Today
                        </div>
                        <div className="pc-button date-arrow" onClick={noDefault(() => m.AddDays(1))}>
                            <span className="glyphicon glyphicon-chevron-left mirror-glyphicon IE-mirror-glyphicon"></span>
                        </div>
                        <div ref={this.calendarRef} className="datepicker-widget"></div>
                    </div>

                    <div className="pc-button date-calendar" onClick={noDefault(() => this.calendar.open())}>
                        <span className="glyphicon glyphicon-calendar"></span>
                    </div>

                    <div className="date-text">
                        {tzmoment(m.Date()).format('ddd MMM D, YYYY')}
                    </div>
                </div>
            );
        }
    },
    ServicesTable = SuperCritical(({ model: m } : { model : ServicesDashboard }) =>
        <table className={cx('table', {
                'sort-reversed': m.SortReversed()
            })}>
            <TableHead model={m} />
            <TableBody model={m} />
        </table>
    ),
    TableHead = SuperCritical(({ model: m } : { model : ServicesDashboard }) =>
        <thead>
            <tr>
                {Columns.map(col =>
                    <th className={'col-' + Column[col].toLowerCase() + (m.Sort() === col ? ' sort-col' : '')} onClick={noDefault(() => m.SortToggle(col))} key={col}>
                        <a href="">{Column[col]}</a><i></i>
                    </th>
                )}
                <th className="col-link">
                    <a href="" onClick={noDefault(() => void 0)}>Link</a>
                </th>
            </tr>
        </thead>
    ),
    TableBody = SuperCritical(({ model: m } : { model : ServicesDashboard }) =>
        <tbody>
            {m.DisplayedServices().map(row =>
                <TableRow row={row} key={row.Id()} onClick={m.OnClickService} />
            )}
        </tbody>
    ),
    TableRow = SuperCritical(({ row, onClick } : { row : TopicCard, onClick : (s : TopicCard) => void }) =>
        <tr onClick={() => onClick(row)}>
            <td className="col-status">{StatusNames[row.Status()]}</td>
            <td className="col-time">{row.TimeEntry.Response() && tzmoment(row.TimeEntry.Response()!).format('HH:mm')}</td>
            <td className="col-label">{row.AmenityType() && row.AmenityType()!.Name()}</td>
            <td className="col-topic">{row.Title()}</td>
            <td className="col-vessel">{row.PortCall() && row.PortCall()!.DisplayVesselIdentifier()}</td>
            <td className="col-berth">{row.Berth() && row.Berth()!.Location() && row.Berth()!.Location()!.Name()}</td>
            <td className="col-link"><a>View Card</a></td>
        </tr>
    );


// WEBPACK FOOTER //
// ./apps/portcall/berthmgrdashboard/servicesdashboardview.tsx